<template>
  <div class="pdiscon" dir="rtl" v-if="page_loaded" :key="profile.id">

    <!-- unsubscribe confirm modal -->
    <ui-modal
      v-model="showConfirm"
      title="ביטול מנוי"
      size="sm"
      :closable="true"
      @close="showConfirm = false"
    >
      <div class="pdiscon__confirm-body">
        <div class="pdiscon__confirm-icon" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        </div>
        <p class="pdiscon__confirm-text">פעולה זו תבטל את המנוי שלך לאלתר. האם אתה בטוח?</p>
      </div>
      <template slot="footer">
        <ui-button variant="ghost" size="md" @click="showConfirm = false">חזרה</ui-button>
        <ui-button variant="danger" size="md" :loading="unsubscribing" @click="doUnsubscribe">בטל מנוי</ui-button>
      </template>
    </ui-modal>

    <!-- success/info banner -->
    <div v-if="bannerMsg" class="pdiscon__banner" :class="'pdiscon__banner--' + bannerType" role="status" aria-live="polite">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
      <span>{{ bannerMsg }}</span>
    </div>

    <div class="pdiscon__page">
      <h1 class="pdiscon__title">עוד רגע וסיימנו..</h1>
      <p class="pdiscon__subtitle">נשמח אם תוכל לספר בכמה מילים מדוע החלטת לסיים את השירות.</p>

      <form class="pdiscon__form" @submit.prevent="onSubmit" novalidate>

        <!-- reason -->
        <div class="pdiscon__field">
          <ui-input
            label="סיבת הניתוק"
            v-model="profile.reason"
            placeholder="ספר לנו..."
            :required="true"
            :error="errors.reason"
          />
        </div>

        <!-- rating groups -->
        <div class="pdiscon__rating-group" v-for="q in questions" :key="q.field">
          <p class="pdiscon__rating-label">{{ q.label }}</p>
          <div class="pdiscon__rating-row" role="radiogroup" :aria-label="q.label">
            <label
              v-for="n in 5"
              :key="q.field + n"
              class="pdiscon__rating-option"
              :class="{ 'pdiscon__rating-option--active': profile[q.field] == String(n) }"
            >
              <input
                type="radio"
                :name="q.field"
                :value="String(n)"
                v-model="profile[q.field]"
                class="pdiscon__radio-native"
              />
              <span class="pdiscon__rating-num">{{ n }}</span>
              <span class="pdiscon__rating-desc">{{ q.labels[n - 1] }}</span>
            </label>
          </div>
        </div>

        <!-- actions -->
        <div class="pdiscon__actions">
          <router-link to="/user" class="pdiscon__cancel-link">
            <ui-button variant="ghost" size="lg" type="button">ביטול</ui-button>
          </router-link>
          <ui-button variant="danger" size="lg" type="submit" :loading="saving">שלח ונתק</ui-button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import UiModal  from './ui/Modal.vue';
import UiButton from './ui/Button.vue';
import UiInput  from './ui/Input.vue';

export default {
  components: { UiModal, UiButton, UiInput },
  data() {
    return {
      page_loaded: false,
      id: this.$route.params.id,
      profile: false,
      restrictions: [],
      saved_restrictions: [],
      insert_mode: false,
      saving: false,
      unsubscribing: false,
      showConfirm: false,
      bannerMsg: '',
      bannerType: 'info',
      errors: { reason: '' },
      questions: [
        {
          field: 'contents',
          label: 'באיזו מידה היית מרוצה ממגוון התכנים באתר?',
          labels: ['בכלל לא', 'במידה מועטה', 'במידה בינונית', 'במידה רבה', 'במידה רבה מאוד'],
        },
        {
          field: 'quality',
          label: 'באיזו מידה היית מרוצה מאיכות התכנים?',
          labels: ['בכלל לא', 'במידה מועטה', 'במידה בינונית', 'במידה רבה', 'במידה רבה מאוד'],
        },
        {
          field: 'comfortable',
          label: 'באיזו מידה האתר היה נוח לשימוש?',
          labels: ['בכלל לא', 'במידה מועטה', 'במידה בינונית', 'במידה רבה', 'במידה רבה מאוד'],
        },
      ],
    };
  },
  computed: {
    restrictions_list() {
      var restrictions = JSON.parse(JSON.stringify(this.$store.state.restrictions));
      for (let i in restrictions) {
        restrictions[i].is_active = (this.saved_restrictions.indexOf(restrictions[i].id) !== -1);
      }
      return restrictions;
    },
  },
  methods: {
    toggle_rest(id) {
      var index = this.saved_restrictions.indexOf(id);
      if (index === -1) {
        this.saved_restrictions.push(id);
      } else {
        this.saved_restrictions.splice(index, 1);
      }
    },

    onSubmit() {
      this.errors.reason = '';
      if (!this.profile.reason || !this.profile.reason.trim()) {
        this.errors.reason = 'נא לציין את סיבת הניתוק';
        return;
      }
      this.save();
    },

    save() {
      this.saving = true;
      this.api_call({
        url: 'save_disconect',
        data: {
          insert_mode: this.insert_mode,
          id: this.id,
          reason: this.profile.reason,
          contents: this.profile.contents,
          quality: this.profile.quality,
          restrictions: this.profile.restrictions,
          comfortable: this.profile.comfortable,
        },
        onComplete: () => {
          this.saving = false;
          this.showConfirm = true;
        },
      });
    },

    doUnsubscribe() {
      this.unsubscribing = true;
      this.api_call({
        url: 'user/cancel_subscription',
        onComplete: () => {
          this.unsubscribing = false;
          this.showConfirm = false;
          this.bannerType = 'success';
          this.bannerMsg = 'המנוי בוטל בהצלחה';
          this.api_call({
            url: 'general',
            onComplete: (data) => {
              this.user = data.data.data.user;
              setTimeout(() => { document.location = '/user'; }, 1500);
            },
          });
        },
      });
    },
  },
  mounted() {
    if (this.id > 0) {
      this.api_call({
        url: 'get_profile',
        data: { id: this.id },
        onComplete: (data) => {
          data.data.data.perms_show_alerts = (data.data.data.perms_show_alerts == 1);
          data.data.data.perms_auto_skip   = (data.data.data.perms_auto_skip == 1);
          data.data.data.perms_block_items = (data.data.data.perms_block_items == 1);
          this.profile = data.data.data;
          this.page_loaded = true;
          this.saved_restrictions = data.data.data.restrictions;
        },
      });
    } else {
      this.insert_mode = true;
      this.page_loaded = true;
      this.profile = { name: '', age: '', restrictions: [], limit_hours: '', password: '' };
    }
  },
};
</script>

<style scoped lang="scss">
.pdiscon {
  min-height: 100vh;
  background: var(--color-bg);
  font-family: var(--font-hebrew);
  padding-block: var(--space-12);
}

.pdiscon__page {
  max-width: 600px;
  margin-inline: auto;
  padding-inline: var(--space-6);
}

.pdiscon__title {
  font-size: 28px;
  font-weight: 700;
  color: var(--color-text);
  letter-spacing: -0.4px;
  margin-block-end: var(--space-2);
  text-align: center;
}

.pdiscon__subtitle {
  font-size: 15px;
  color: var(--color-textMuted);
  text-align: center;
  margin-block-end: var(--space-8);
}

.pdiscon__form {
  background: var(--color-surface1);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--space-8);
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
}

.pdiscon__field {
  /* font override for hebrew */
  --font-sans: var(--font-hebrew);
}

/* rating question */
.pdiscon__rating-group {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.pdiscon__rating-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0;
}

.pdiscon__rating-row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.pdiscon__rating-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  min-width: 64px;
}

.pdiscon__radio-native {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.pdiscon__rating-num {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
  background: var(--color-surface2);
  border: 1px solid var(--color-border);
  font-size: 16px;
  font-weight: 600;
  color: var(--color-textMuted);
  font-family: var(--font-mono);
  transition: all var(--duration-fast) var(--easing-default);
}

.pdiscon__rating-option--active .pdiscon__rating-num {
  background: var(--color-accent);
  border-color: var(--color-accent);
  color: #fff;
}

.pdiscon__rating-option:focus-within .pdiscon__rating-num {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.pdiscon__rating-desc {
  font-size: 11px;
  color: var(--color-textMuted);
  text-align: center;
  max-width: 64px;
}

/* actions */
.pdiscon__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--space-3);
  border-block-start: 1px solid var(--color-border);
  padding-block-start: var(--space-6);
}

.pdiscon__cancel-link {
  text-decoration: none;
}

/* banner */
.pdiscon__banner {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: 14px 20px;
  border-radius: var(--radius-md);
  font-size: 14px;
  margin-block-end: var(--space-6);
  max-width: 600px;
  margin-inline: auto;
}

.pdiscon__banner--success {
  background: rgba(31,174,107,0.12);
  border: 1px solid rgba(31,174,107,0.33);
  color: var(--color-success);
}

.pdiscon__banner--info {
  background: rgba(59,130,246,0.12);
  border: 1px solid rgba(59,130,246,0.33);
  color: var(--color-info);
}

/* confirm dialog content */
.pdiscon__confirm-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);
  text-align: center;
}

.pdiscon__confirm-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(224,65,65,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-danger);
}

.pdiscon__confirm-text {
  font-size: 14px;
  color: var(--color-textMuted);
  line-height: 1.5;
  margin: 0;
}

@media (prefers-reduced-motion: reduce) {
  .pdiscon__rating-num {
    transition: none;
  }
}
</style>
